/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { checkPermission } from "../Settings/Settings";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);
  }

  render() {
    var currentPage = this.props.currentPage;
    return (
      <div className="sticky">
        <div className="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
        <div className="app-sidebar">
          <div className="side-header">
            <a className="header-brand1" href={void 0}>
              <h3 className="header-brand-img light-logo1">
                {" "}
                ResMax Power Tech
              </h3>
              <h3 className="header-brand-img light-logo">
                {" "}
                Res
                <br />
                Max
              </h3>
              {/*  <img
                src="../assets/images/brand/logo.png"
                className="header-brand-img desktop-logo"
                alt="logo"
              />
              <img
                src="../assets/images/brand/logo-1.png"
                className="header-brand-img toggle-logo"
                alt="logo"
              />
              <img
                src="../assets/images/brand/logo-2.png"
                className="header-brand-img light-logo"
                alt="logo"
              />
              <img
                src="../assets/images/brand/logo-3.png"
                className="header-brand-img light-logo1"
                alt="logo"
              /> */}
            </a>
          </div>
          <div className="main-sidemenu">
            <div className="slide-left disabled" id="slide-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
              </svg>
            </div>
            <ul className="side-menu">
              {checkPermission("dashboard", "view") === true && (
                <li className="slide ">
                  <Link
                    to={"/dashboard"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "sashboard" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fe fe-home"></i>
                    <span className="side-menu__label">Dashboard</span>
                  </Link>
                </li>
              )}
              {checkPermission("department", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/department"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "department" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                    href="index.html"
                  >
                    <i className="side-menu__icon fa fa-building"></i>
                    <span className="side-menu__label">Department</span>
                  </Link>
                </li>
              )}
              {(checkPermission("employee", "view") === true ||
                checkPermission("attanance", "view") === true) && (
                <li
                  className={`slide ${
                    ["employee", "attendance"].indexOf(
                      this.props.currentPage
                    ) >= 0
                      ? "is-expanded"
                      : ""
                  }`}
                >
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href={void 0}
                  >
                    <i className="side-menu__icon fa fa-users"></i>
                    <span className="side-menu__label">Employee</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                  <ul className="slide-menu">
                    {checkPermission("employee", "view") === true && (
                      <li>
                        <Link
                          to={"/employee"}
                          className={`slide-item ${
                            this.props.currentPage === "employee"
                              ? "active"
                              : ""
                          }`}
                        >
                          Employee
                        </Link>
                      </li>
                    )}
                    {checkPermission("attanance", "view") === true && (
                      <li>
                        <Link
                          to={"/attendance"}
                          className={`slide-item ${
                            this.props.currentPage === "attendance"
                              ? "active"
                              : ""
                          }`}
                        >
                          Attendance
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {(checkPermission("user", "view") === true ||
                checkPermission("userrole", "view") === true) && (
                <li
                  className={`slide ${
                    ["users", "userroles"].indexOf(this.props.currentPage) >= 0
                      ? "is-expanded"
                      : ""
                  }`}
                >
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href={void 0}
                  >
                    <i className="side-menu__icon fe fe-user"></i>
                    <span className="side-menu__label">User</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                  <ul className="slide-menu">
                    {checkPermission("user", "view") === true && (
                      <li>
                        <Link
                          to={"/users"}
                          className={`slide-item ${
                            this.props.currentPage === "users" ? "active" : ""
                          }`}
                        >
                          Users
                        </Link>
                      </li>
                    )}
                    {checkPermission("userrole", "view") === true && (
                      <li>
                        <Link
                          to={"/userroles"}
                          className={`slide-item ${
                            this.props.currentPage === "userroles"
                              ? "active"
                              : ""
                          }`}
                        >
                          User Role
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {checkPermission("brand", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/brand"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "brand" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-bold"></i>
                    <span className="side-menu__label">Brand</span>
                  </Link>
                </li>
              )}
              {checkPermission("products", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/products"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "products" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-product-hunt"></i>
                    <span className="side-menu__label">Products</span>
                  </Link>
                </li>
              )}
              {checkPermission("customer", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/customer"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "customer" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-users"></i>
                    <span className="side-menu__label">Customer</span>
                  </Link>
                </li>
              )}
              {checkPermission("customer", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/shipto"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "shipto" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-users"></i>
                    <span className="side-menu__label">Ship To</span>
                  </Link>
                </li>
              )}
              {checkPermission("vendor", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/vendors"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "vendor" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-users"></i>
                    <span className="side-menu__label">Vendor</span>
                  </Link>
                </li>
              )}
              {checkPermission("purchaseorder", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/purchaseorder"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "purchaseorder" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-shopping-cart"></i>
                    <span className="side-menu__label">Purchase Order</span>
                  </Link>
                </li>
              )}
              {checkPermission("purchase", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/purchase"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "purchase" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-shopping-cart"></i>
                    <span className="side-menu__label">Purchase</span>
                  </Link>
                </li>
              )}
              {checkPermission("sale", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/sale"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "sale" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-shopping-cart"></i>
                    <span className="side-menu__label">Sale</span>
                  </Link>
                </li>
              )}
              {checkPermission("jobstatus", "view") === true && (
                <li className="slide">
                  <Link
                    to={"/jobs"}
                    className={`side-menu__item has-link ${
                      this.props.currentPage === "jobs" ? "active" : ""
                    }`}
                    data-bs-toggle="slide"
                  >
                    <i className="side-menu__icon fa fa-briefcase"></i>
                    <span className="side-menu__label">Jobs</span>
                  </Link>
                </li>
              )}
              {(checkPermission("productwisereport", "view") === true ||
                checkPermission("customerwisereport", "view") === true ||
                checkPermission("paymenttrackingreport", "view") === true ||
                checkPermission("salesreport", "view") === true ||
                checkPermission("purchasereport", "view") === true ||
                checkPermission("engineersalereport", "view") === true ||
                checkPermission("gstreport", "view") === true || checkPermission("purchaseorderreport", "view") === true) && (
                <li
                  className={`slide ${
                    [
                      "product-report",
                      "customer-report",
                      "payment-tracking",
                      "purchase-report",
                      "purchase-order-report",
                      "sales-report",                      
                      "engineer-report",
                      "gst-report",
                      "statistics-report"
                    ].indexOf(this.props.currentPage) >= 0
                      ? "is-expanded"
                      : ""
                  }`}
                >
                  <a
                    className="side-menu__item"
                    data-bs-toggle="slide"
                    href={void 0}
                  >
                    <i className="side-menu__icon fa fa-flag"></i>
                    <span className="side-menu__label">Reports</span>
                    <i className="angle fe fe-chevron-right"></i>
                  </a>
                  <ul className="slide-menu">
                    {checkPermission("productwisereport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/product"}
                          className={`slide-item ${
                            this.props.currentPage === "product-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Product Wise
                        </Link>
                      </li>
                    )}
                    {checkPermission("customerwisereport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/customer"}
                          className={`slide-item ${
                            this.props.currentPage === "customer-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Customer Wise
                        </Link>
                      </li>
                    )}
                    {checkPermission("paymenttrackingreport", "view") ===
                      true && (
                      <li>
                        <Link
                          to={"/report/payment-tracking"}
                          className={`slide-item ${
                            this.props.currentPage === "payment-tracking"
                              ? "active"
                              : ""
                          }`}
                        >
                          Payment Tracking Report
                        </Link>
                      </li>
                    )}
                    {checkPermission("purchaseorderreport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/purchaseorder"}
                          className={`slide-item ${
                            this.props.currentPage === "purchase-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Purches Order Report
                        </Link>
                      </li>
                    )}
                    {checkPermission("purchasereport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/purchase"}
                          className={`slide-item ${
                            this.props.currentPage === "purchase-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Purches Report
                        </Link>
                      </li>
                    )}
                    {checkPermission("salesreport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/sales"}
                          className={`slide-item ${
                            this.props.currentPage === "sales-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Sales Report
                        </Link>
                      </li>
                    )}
                    {checkPermission("gstreport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/gstreport"}
                          className={`slide-item ${
                            this.props.currentPage === "gst-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          GST Report
                        </Link>
                      </li>
                    )}
                    {checkPermission("purchasereport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/statistics"}
                          className={`slide-item ${
                            this.props.currentPage === "statistics-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Statistics
                        </Link>
                      </li>
                    )}
                    {checkPermission("engineersalereport", "view") === true && (
                      <li>
                        <Link
                          to={"/report/engineer"}
                          className={`slide-item ${
                            this.props.currentPage === "engineer-report"
                              ? "active"
                              : ""
                          }`}
                        >
                          Enginer Sale Report
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
            </ul>
            <div className="slide-right" id="slide-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
